import { create } from "zustand";

const LAST_SYNC_KEY = "sync:lastSyncAt";

interface SyncState {
  syncing: boolean;
  lastSyncAt: string | null;
  error: string | null;
  setSyncing: (syncing: boolean) => void;
  setLastSyncAt: (at: string) => void;
  setError: (error: string | null) => void;
}

const storedLastSync =
  typeof localStorage !== "undefined" ? localStorage.getItem(LAST_SYNC_KEY) : null;

export const useSyncStore = create<SyncState>((set) => ({
  syncing: false,
  lastSyncAt: storedLastSync,
  error: null,
  setSyncing: (syncing) => set({ syncing }),
  setLastSyncAt: (lastSyncAt) => set({ lastSyncAt }),
  setError: (error) => set({ error }),
}));
